var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExploreThinV3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 28 24",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1268.95,-1241.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circled-friends-lines",
    transform: "matrix(0.474243,0,0,0.711574,-2452.93,730.742)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7848.05,
    y: 718.398,
    width: 59.042,
    height: 33.728,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.10863,0,0,1.40534,5172.31,-1026.94)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1282.95,1243.96C1277.43,1243.96 1272.95,1248.44 1272.95,1253.96C1272.95,1259.48 1277.43,1263.96 1282.95,1263.96C1288.47,1263.96 1292.95,1259.48 1292.95,1253.96C1292.95,1248.44 1288.47,1243.96 1282.95,1243.96ZM1282.95,1244.96C1287.92,1244.96 1291.95,1248.99 1291.95,1253.96C1291.95,1258.92 1287.92,1262.96 1282.95,1262.96C1277.98,1262.96 1273.95,1258.92 1273.95,1253.96C1273.95,1248.99 1277.98,1244.96 1282.95,1244.96ZM1281.23,1252.01L1281.14,1252.06L1281.07,1252.13L1281.02,1252.21L1281,1252.23L1278,1258.23C1277.91,1258.43 1277.94,1258.66 1278.1,1258.81C1278.25,1258.96 1278.48,1259 1278.67,1258.9L1284.72,1255.88L1284.79,1255.83L1284.86,1255.75L1284.9,1255.68L1287.9,1249.68C1287.99,1249.49 1287.96,1249.26 1287.8,1249.1C1287.65,1248.95 1287.42,1248.91 1287.23,1249.01L1281.23,1252.01ZM1279.57,1257.34L1283.61,1255.32L1281.59,1253.3L1279.57,1257.34Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreThinV3);
export default __webpack_public_path__ + "static/media/explore_thin_v3.5c793254164b888d0ae48a3519ddaa3c.svg";
export { ForwardRef as ReactComponent };